import { print } from "graphql";
import gql from "graphql-tag";
import axios from "axios";

const states = ["NY", "NJ", "CA", "CT", "FL", "PA", "TX"];

const STATE_QUERY = gql`
  query gpsMapsByState($state: String!) {
    gpsMapsByState(state: $state) {
      city
      state
      panel
      lat
      lng
      systemsize
      Installation_Complete
    }
  }
`;
const QUERY = gql`
  query proposal($oppnum: String) {
    proposal(oppnum: $oppnum) {
      id
      activityid
      oppnum
      RepName
      RepEmail
      AppointmentStartString
      AppointmentTimeString
      AppointmentDateString
      momentdate
      Lead
      CustomerName
      Office
      Address
      City
      State
      Zip
      Canvasser
      ProposalStatus
      Notes
      type
      panels
      inverter
      module
      PVArray
      production
      datasheetcomplete
      reprequest
      pimg
      repnotes
      timeAssigned
      timeAssignedUnix
      proposalCompleted
      proposalStarted
      user {
        id
        proposalAgentEmail
        proposalAgentName
      }
    }
  }
`;

const queryMS = (oppnum) =>
  axios.post(
    "https://z1puyl5f7c.execute-api.us-east-1.amazonaws.com/dev/graphql",
    {
      query: print(QUERY),
      variables: { oppnum },
    }
  );

const queryStates = (state) =>
  axios.post(
    "https://gbiv8i3n4m.execute-api.us-east-1.amazonaws.com/production/graphql",
    {
      query: print(STATE_QUERY),
      variables: { state },
    }
  );
const queryAddress = (address) =>
  axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyCR7yTvbSisKRJcpb20uNWQ_wZLWuCive8`
  );

const variants = {
  closed: {
    width: "100%",
    height: "100%",
    // top: "20%",
    // left: "10%",
  },
  open: {
    width: "100vw",
    top: 0,
    left: 0,
    height: "100vh",
  },
};

const styleJson = [
  {
    featureType: "all",
    elementType: "geometry",
    stylers: [
      {
        color: "#202c3e",
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      {
        gamma: 0.01,
      },
      {
        lightness: 20,
      },
      {
        weight: "1.39",
      },
      {
        color: "#ffffff",
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        weight: "0.96",
      },
      {
        saturation: "9",
      },
      {
        visibility: "on",
      },
      {
        color: "#000000",
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        lightness: 30,
      },
      {
        saturation: "9",
      },
      {
        color: "#29446b",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        saturation: 20,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        lightness: 20,
      },
      {
        saturation: -20,
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        lightness: 10,
      },
      {
        saturation: -30,
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#193a55",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
      {
        saturation: 25,
      },
      {
        lightness: 25,
      },
      {
        weight: "0.01",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        lightness: -20,
      },
    ],
  },
];
// styles
const mapStyles = {
  width: "100%",
  height: "100%",
};

export {
  QUERY,
  queryMS,
  queryAddress,
  queryStates,
  states,
  variants,
  styleJson,
  mapStyles,
};
